<template>
    <div class="home">
        <div class="banner__wrapper">
            <div class="banner__wrapper">
                <div class="banner__inner">
                    <div class="banner-img__wrapper">
                        <swiper :options="swiperOption" ref="mySwiper">
                            <swiper-slide>
                                <img class="smallImg" src="./../assets/img/img_bg1_home.png">
                                <img src="http://www.lvshouhotel.com/lvshouhotel/img_bg_chazhaojieguo.png" alt="">
                            </swiper-slide>
                            <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_bg_chazhaojieguo2.jpg" alt=""></swiper-slide>
                            <swiper-slide><img src="http://www.lvshouhotel.com/lvshouhotel/img_bg_chazhaojieguo3.jpg" alt=""></swiper-slide>
                        </swiper>
                        <div :style="'height:254px;width: 100%;z-index: 1001;position: absolute;opacity: 0.3;transform: scaleY(-1);background-image: linear-gradient(180deg, #000000 0%, rgba(1,1,0,0.88) 15%, rgba(8,7,1,0.00) 100%);bottom:0'"></div>
                        <div class="dot"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="count">
            <h1>客房与套房</h1>
            <p>绿瘦酒店拥有豪华客房和套房共265间，设有管家服务、客房送餐服务、礼宾服务、洗衣服务及多国语言翻译服务，能满足您商务与休闲的不同需求。</p>
        </div>
        <div class="room">
            <div class="room-list clearfix ">
                <div class="item"  @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)" v-for="(item, index) in roomList" :key="index" @click="handleItem(index)">
                    <div class="over" :class="{'show':item.overShow == 1}" >
                        <div class="over-img">
                            <img src="./../assets/img/room_qrcode.png" alt="">
                        </div>
                        <div class="over-text">微信扫描二维码</div>
                    </div>
                    <img :src="item.url" alt="">
                    <h2 class="room-type">{{item.name}}</h2>
                    <p class="desc"><span>{{item.roomType}}</span>    <span>{{item.serviceType}}</span>    <span>{{item.bed}}</span></p>
                    <p class="price">&nbsp;</p>
                    <!-- <p class="price">￥{{item.price}}元/天</p> -->
                    <button class="btn" @click="xunjia(item)">预订</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import room from "@/assets/json/room"
export default {
  data () {
    return {
      swiperOption: {
        autoplay:  {
            delay: 4000,
            stopOnLastSlide: true,
            disableOnInteraction: false,
        },
        loop : true,
        effect : 'slide',
        pagination: {
            el: '.dot',
            clickable :true
        },
      },
      selectIndex: "",
      itemList: [],
      roomList: room
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
      mouseenter(item){
        item.overShow = 1
      },
      mouseleave(item){
        item.overShow = 0
      },
      handleItem(index){
          return
          this.selectIndex = index;
      },
      xunjia(item){
          return
          let getOverShow = item.overShow
          this.roomList.forEach(element => {
            element.overShow = 0
          });
          item.overShow = getOverShow == 1 ? 0 : 1
          console.log("item",this.roomList)
          //window.open('https://hotels.ctrip.com/hotel/479401.html#ctm_ref=www_hp_bs_lst')
      }
  }
}
</script>
<style>
.dot{
    position: absolute;
    bottom: 40px;
    z-index: 1001;
    left: 50%;
    transform: translateX(-50%);
}
.dot .swiper-pagination-bullet{
    display: inline-block;
    background: #F2EFE8;
    width: 12px;
    height: 12px;
    border-radius: 0;
    opacity: 1;
    cursor: pointer;
    
}
.dot .swiper-pagination-bullet:focus{
    outline: none;
}
.swiper-pagination-bullet + .swiper-pagination-bullet{
  margin-left: 10px;
}
.dot .swiper-pagination-bullet-active{
    background: #E8DFCA;
    opacity: 1;
}   
</style>
<style lang="less" scoped>
.banner__wrapper{
  height: 769px;
  .banner-img__wrapper {
    position: absolute;
    z-index: 1000;
    width: 1920px;
    height: 769px;
    left: 50%;
    margin-left: -960px;
    .swiper-slide{
         height: 769px;
        img{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
        }
        
    }
  }
  .banner__inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      height: 769px;
      min-width: 1244px;
    }
}
.count{
    width: 1200px;
    margin: 60px auto;
    h1{
        font-size: 30px;
        color: #333333;
        letter-spacing: 1.58px;
    }
    p{
        margin-top: 20px;
        font-size: 16px;
        color: #333333;
        letter-spacing: 1px;
    }
}
.room{
    width: 100%;
    background: #F4F4F4;
    padding: 100px 0;
    .room-list{
        width: 1246px;
        margin: 0 auto; 
        .item{
            float: left;
            width: 370px;
            height: 451px;
            background: #FFFFFF;
            border: 1px solid rgba(232,232,232,0.79);
            cursor: pointer;
            margin: 20px 0 20px 20px;
            position: relative;
            .over{
                position: absolute;
                width: 100%;
                height: 390px;
                left: 0;
                top: -65px;
                background: #fff;
                // background:#fff url('./../assets/img/room_item_over_icon.png') no-repeat center bottom;
                box-shadow: 0 0 60px 0px rgba(0, 0, 0, 0.08);
                border: 1px solid rgba(232, 232, 232, 0.79);
                box-sizing: border-box;
                // background-size: 100% 390px;
                text-align: center;
                opacity: 0;
                z-index: -1;
                &.show{
                    opacity:1;
                    z-index: 1;
                    top: -45px;
                    transition: all .5s ease;
                }
                &::after{
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: -16px;
                    margin: auto;
                    width: 32px;
                    height: 17px;
                    background: url('./../assets/img/room_item_over_icon.png') no-repeat center center;
                }
                .over-img{
                    text-align: center;
                    height: 280px;
                    padding: 38px 0 0 0;
                }
                .over-img img{
                    width: 220px;
                    height: 220px;
                    display: inline-block;
                    margin-top: 20px;
                }
                .over-text{
                    font-size: 20px;
                    line-height: 20px;
                    padding: 16px 0;
                    color: #333333;
                    letter-spacing: 2px;
                }
            }
            img{
                width: 370px;
                height: 225px;
            }
            .room-type{
                font-size: 20px;
                color: #97824B;
                letter-spacing: 2px;
                padding: 0 20px;
                margin-top: 20px;
            }
            .desc{
                padding: 10px 20px;
                span+span{
                    margin-left: 30px;
                }
            }
            .price{
                font-size: 14px;
                color: #333333;
                letter-spacing: 1px;
                padding: 0 20px;
            }
            .btn{
                border: 1px solid #BCA059;
                font-size: 18px;
                color: #BCA059;
                letter-spacing: 1px;
                background: transparent;
                display: block;
                margin: 30px auto;
                width: 138px;
                height: 40px;
                cursor: pointer;
            }
            .btn:hover,.btn:focus{
                // box-shadow: 0px 0px 25px rgb(219, 219, 219);
                outline: none;
                color: rgb(135, 106, 32);
                border-color:rgb(135, 106, 32);;
            }
        }
        .item:nth-child(3n - 1){
            margin: 20px 20px 20px 40px;
        }
        .item:nth-child(n + 4){
            margin-top: 40px;
        }
        .item:hover{
            box-shadow: 0px -3px 28px rgb(219, 219, 219);
        }
        .item-on{
            box-shadow: 0px -3px 28px rgb(219, 219, 219);
        }
        
    }
}
</style>